import { createClient } from '@supabase/supabase-js';
import { env } from './env';

// Distinct storageKey so a Go session never collides with a main-app or
// admin-portal session when served from the same origin during development.
export const supabase = createClient(env.supabaseUrl, env.supabaseAnonKey, {
  auth: { storageKey: 'pdpo-go-auth' },
});
